import { Module } from "wrapper6";
import { objectFit } from "../utils/_object-fit";

export default class InstagramFeed extends Module {
    ready() {
        
        const TARGET = document.getElementById('mtt-instafeed-target');

        let data = {
            'action': 'lazyload_instagram'
        };

        jQuery.post(main_theme_objects.ajax_url, data, (response) => {
            (TARGET && response !== 0) ? TARGET.innerHTML = response.markup : '';
            objectFit();
        });

    }
}
